import { styled, IconButton, IconButtonProps } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export interface ExpandMoreProps extends IconButtonProps {
  expanded: boolean
  setExpanded: (newExpanded: boolean) => void
}

export const ExpandMoreButton = styled((props: ExpandMoreProps) => {
  const { expanded, setExpanded, ...other } = props
  const handleExpandClick = () => setExpanded(!expanded)

  return <IconButton onClick={handleExpandClick} {...other}><ExpandMoreIcon/></IconButton>
})(({ theme }) => ({
  // marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expanded }) => !expanded,
      style: {
        transform: 'rotate(0deg)',
      },
    },
    {
      props: ({ expanded }) => !!expanded,
      style: {
        transform: 'rotate(180deg)',
      },
    },
  ],
}));
